import type {ListSortingState} from './ListSortingSelect';

export interface DateRange {
  from: Date;
  to: Date;
}

export interface ListSortFieldConfig<T> {
  i18nKey: string;
  defaultDesc: boolean;
  getValue: (item: T) => string | number | null;
}

export interface ListSortConfig<T> {
  order: readonly string[];
  fields: Record<string, ListSortFieldConfig<T>>;
}

export function parseSortState<T>(
  sorting: ListSortingState,
  config: ListSortConfig<T>
): {field: string | undefined; desc: boolean} {
  const first = sorting[0];
  if (!first) return {field: undefined, desc: true};
  const field = config.order.find(o => o === first.id);
  return {field, desc: first.desc};
}
